import { render, staticRenderFns } from "./RefereeList.vue?vue&type=template&id=d495df92&scoped=true&"
import script from "./RefereeList.vue?vue&type=script&lang=js&"
export * from "./RefereeList.vue?vue&type=script&lang=js&"
import style0 from "./RefereeList.vue?vue&type=style&index=0&id=d495df92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d495df92",
  null
  
)

export default component.exports